import React from 'react';
import { Outlet } from 'react-router-dom';

const Admin = () => {
  return (
    <section
      className="m-4"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 120px)',
        minWidth: 0,
      }}
    >
      <h4 className="mt-0 mb-0 text-cisco-blue-60 leading-6">
        Admin
      </h4>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          minWidth: 0,
        }}
      >
        <Outlet />
      </div>
    </section>
  );
};

export default Admin;